import { Button } from '@/components/ui/button';

type TabItem<T extends string> = {
  value: T;
  label: string;
};

type TabsProps<T extends string> = {
  tabs: readonly TabItem<T>[];
  activeTab: T;
  onChange: (tab: T) => void;
  className?: string;
};

export function Tabs<T extends string>({
  tabs,
  activeTab,
  onChange,
  className = '',
}: TabsProps<T>) {
  return (
    <div className={`flex w-full ${className}`}>
      {tabs.map((tab) => (
        <Button
          key={tab.value}
          variant="ghost"
          onClick={() => onChange(tab.value)}
          className={`hover:bg-button-hover-background-wu dark:hover:bg-button-hover-background-wu relative z-10 w-1/2 rounded-none p-2 text-black transition-colors dark:text-white`}
        >
          {tab.label}
          {activeTab === tab.value && (
            <span className="bg-primary-wu absolute bottom-0 left-0 h-0.5 w-full rounded-full" />
          )}
        </Button>
      ))}
    </div>
  );
}
